
(()=>{
const root=document.getElementById('light-schema');
const nodes=[
  [
    "blue",
    0,
    "Blue · 405–470 nm",
    "Blue · 405–470 nm: This group connects to light-absorbing molecules in bacteria and light-sensitive proteins in skin. The 405–420 nm part is especially relevant to porphyrins, molecules in some bacteria that start damaging chemical reactions after absorbing light."
  ],
  [
    "green",
    0,
    "Green · 520–540 nm",
    "Green · 520–540 nm: This group connects to light-sensitive proteins and movement of calcium inside skin cells. Calcium changes the activity of proteins controlling tasks such as releasing substances or producing other proteins."
  ],
  [
    "red-low",
    0,
    "Red · 630–650 nm",
    "Red · 630–650 nm: This group brings together cell-energy and repair pathways with the skin study conducted at 633 nm. That study measured wrinkles, skin’s return to shape after stretching and collagen, the strong protein supporting skin."
  ],
  [
    "red-mid",
    0,
    "Red · 650–660 nm",
    "Red · 650–660 nm: This group contains the hair research at 655 nm and the sleep study at an average of 658 nm. It also includes 660 nm from the original cell-energy and repair schema. The hair study examined growth-related proteins and hair counts; the sleep study measured melatonin, a hormone that helps signal nighttime, and participants’ sleep ratings."
  ],
  [
    "red-high",
    0,
    "Red · 660–670 nm",
    "Red · 660–670 nm: This group contains 660 nm from the cell-energy and repair schema and the glucose study at 670 nm. The glucose study measured how high blood sugar rose and how long it stayed elevated after a glucose drink."
  ],
  [
    "nir",
    0,
    "NIR · 810–850 nm",
    "NIR · 810–850 nm: Near-infrared (NIR) is invisible light beyond visible red and reaches relatively deeper tissue. This group combines the overlapping cell-energy and repair connections. The linked thyroid and skin studies used 830 nm: researchers measured replacement-hormone needs, wrinkles and collagen, the protein that supports skin."
  ],
  [
    "mito",
    1,
    "Mitochondrial respiration + redox signaling",
    "Mitochondrial respiration makes adenosine triphosphate (ATP), the molecule cells use to power work such as muscle contraction and tissue repair. Redox signaling changes the chemistry of proteins. In simple terms, those changes alter what the proteins do, helping the cell adjust energy production and its response to damage."
  ],
  [
    "no",
    1,
    "Nitric oxide + CCO signaling",
    "Nitric oxide (NO) tells muscle in blood-vessel walls to relax, making more room for blood to pass. Cytochrome-c oxidase (CCO) helps cells use oxygen to make energy. In simple terms, this pathway concerns both delivering oxygen to tissue and using that oxygen once it reaches cells."
  ],
  [
    "repair",
    1,
    "ROS + NO + calcium + gene expression",
    "Reactive oxygen species (ROS) are oxygen-containing molecules that chemically alter proteins and change their activity. Nitric oxide (NO) helps blood vessels widen. A rise in calcium inside a cell activates proteins that control actions such as movement or release of substances. Gene expression makes proteins from genetic instructions. Together, these processes coordinate the work of repair."
  ],
  [
    "defense",
    1,
    "NF-κB + Nrf2 signaling",
    "Nuclear factor kappa B (NF-κB) increases the reading of genes involved in inflammation. Nuclear factor erythroid 2-related factor 2 (Nrf2) increases the reading of genes involved in chemical protection. In simple terms, they change which proteins a cell makes: for example, proteins that call immune cells to an injury or proteins that help remove damaging molecules."
  ],
  [
    "quality",
    1,
    "Mitochondrial biogenesis + dynamics + mitophagy",
    "Mitochondrial biogenesis builds components used to make cell energy. Dynamics means mitochondria join together or divide; joining allows contents to mix, while division helps separate damaged sections. Mitophagy breaks down damaged mitochondria. In simple terms, these are ways of building, maintaining and removing the structures that supply energy for cell work."
  ],
  [
    "porphyrin",
    1,
    "Porphyrin photochemistry",
    "Porphyrins are molecules in some bacteria that absorb light. Photochemistry means the absorbed light supplies energy for a chemical reaction. In simple terms, this reaction produces substances that damage parts of susceptible bacteria, making it harder for those bacteria to survive."
  ],
  [
    "opsin",
    1,
    "Opsin + ion-channel signaling",
    "Opsins are proteins that change shape when they absorb light. This starts a chain of chemical reactions. Ion channels are openings in the cell’s outer membrane that let charged particles enter or leave. In simple terms, light detection changes conditions inside a cell, affecting proteins that control actions such as releasing substances or changing gene activity."
  ],
  [
    "collagen",
    1,
    "Fibroblast activation + collagen synthesis",
    "Fibroblasts are cells that make collagen, a strong protein that supports skin. Activation means these cells increase their activity; synthesis means making new material. In simple terms, this pathway concerns producing and arranging the material that gives skin strength and structure."
  ],
  [
    "thyroidsig",
    1,
    "Thyroid hormone + immune signaling",
    "Thyroid hormones travel in blood and change how cells use energy, affecting processes such as heat production. In Hashimoto’s disease, the immune system attacks the thyroid. In simple terms, the study examined how much replacement hormone people needed and measured immune proteins directed against the gland."
  ],
  [
    "melatonin",
    1,
    "Melatonin signaling",
    "Melatonin is a hormone that binds to receiving proteins on cells involved in the body’s daily timing. In simple terms, it helps tell the body that it is nighttime. The study measured melatonin in blood and asked participants about their sleep."
  ],
  [
    "glucosepath",
    1,
    "Mitochondrial metabolism + glucose utilization",
    "Glucose utilization means taking sugar from the blood into cells and using it as fuel. Mitochondrial metabolism is part of the process that turns fuel into usable energy. In simple terms, the researchers tested whether light exposure changed how much sugar remained in the blood after a glucose drink."
  ],
  [
    "wnt",
    1,
    "Wnt / β-catenin signaling",
    "Wnt is a family of proteins that bind to receiving proteins on cells. β-catenin, pronounced beta-catenin, then helps change which genes are read. In simple terms, this pathway controls instructions involved in growing hair. The laboratory study measured these proteins and growth in human hair follicles, the structures in skin that produce hair."
  ],
  [
    "workout",
    2,
    "Tired muscles after exercise",
    "Exercise uses energy and creates small areas of muscle damage. Recovery involves replacing usable energy, clearing damaged material and making proteins to repair muscle fibers. The connections below explain the cell processes involved in those tasks."
  ],
  [
    "flow",
    2,
    "Reduced blood flow",
    "Blood carries oxygen and nutrients to tissue. When less blood reaches an area, cells receive less of what they need to make energy and maintain themselves. The connections below concern widening blood vessels and using oxygen inside cells."
  ],
  [
    "injury",
    2,
    "Healing after an injury",
    "Healing requires cells to move into the injured area, multiply and make material that replaces damaged tissue. Blood supplies oxygen and nutrients for this work. The connections below describe how cells coordinate those actions."
  ],
  [
    "inflammation",
    2,
    "Ongoing inflammation",
    "Inflammation is the body’s response to injury or infection. Cells release substances that bring immune cells to the area and direct their activity. This target concerns how that response is controlled and how cells handle chemically reactive substances produced during it."
  ],
  [
    "aging",
    2,
    "Antiaging",
    "This target covers changes in the structures that make cell energy and in the material that supports skin. The linked skin study measured wrinkles, skin elasticity—how well skin returns to shape after stretching—and collagen, a strong supporting protein."
  ],
  [
    "demand",
    2,
    "High energy needs",
    "Cells need usable energy to contract muscles, move substances in and out and build new proteins. During demanding activity, they must make that energy faster. This target concerns the reactions that turn food and oxygen into energy for those jobs."
  ],
  [
    "acne",
    2,
    "Surface bacteria / acne",
    "Some bacteria contain molecules that absorb blue light. The absorbed energy starts reactions that damage bacterial material. This target concerns those reactions and changes in bacteria near the skin surface."
  ],
  [
    "skin",
    2,
    "Skin-surface responses",
    "Some skin proteins absorb light and start chemical reactions inside cells. Those reactions affect activities such as releasing substances or changing which proteins are produced. This target concerns these responses near the skin surface."
  ],
  [
    "thyroid",
    2,
    "Hormones / thyroid",
    "The thyroid is a gland that releases hormones into the blood. These hormones influence how cells use energy, including heat production. The linked study examined people with Hashimoto’s disease, in which the immune system attacks the thyroid and hormone production is reduced."
  ],
  [
    "sleep",
    2,
    "Sleep / melatonin",
    "The body follows a daily pattern of sleeping and waking. Melatonin is a hormone that helps communicate when it is nighttime. The linked study measured melatonin in blood and asked participants about the quality of their sleep."
  ],
  [
    "glucose",
    2,
    "Blood glucose response",
    "Glucose is sugar carried in the blood. Cells take it up and use it to make energy. The linked study followed blood sugar after a glucose drink to measure how high it rose and how long it stayed elevated."
  ],
  [
    "hair",
    2,
    "Hair growth",
    "Hair grows from follicles, small structures within the skin. Cells at the base divide and produce the material that forms each hair. This target concerns the proteins that regulate that growth and the hair counts measured in a human study."
  ]
];
nodes.forEach(n=>n[1]=2-n[1]);
const healthPaths={
workout:['mito','repair','defense'],
flow:['mito','no'],
injury:['mito','no','repair','defense'],
inflammation:['mito','defense'],
aging:['mito','quality','collagen'],
thyroid:['thyroidsig'],
sleep:['melatonin'],
glucose:['glucosepath'],
hair:['wnt'],
demand:['mito'],
acne:['porphyrin'],
skin:['opsin']
};
const pathWaves={
  "mito": [
    "red-low",
    "red-mid",
    "red-high",
    "nir"
  ],
  "no": [
    "red-low",
    "red-mid",
    "red-high",
    "nir"
  ],
  "repair": [
    "red-low",
    "red-mid",
    "red-high",
    "nir"
  ],
  "defense": [
    "red-low",
    "red-mid",
    "red-high",
    "nir"
  ],
  "quality": [
    "red-low",
    "red-mid",
    "red-high",
    "nir"
  ],
  "porphyrin": [
    "blue"
  ],
  "opsin": [
    "blue",
    "green"
  ],
  "collagen": [
    "red-low",
    "nir"
  ],
  "thyroidsig": [
    "nir"
  ],
  "melatonin": [
    "red-mid"
  ],
  "glucosepath": [
    "red-high"
  ],
  "wnt": [
    "red-mid"
  ]
};
const routes=[],edges=[],edgeKeys=new Set();
for(const [target,paths] of Object.entries(healthPaths))for(const path of paths)for(const wave of pathWaves[path]){
 routes.push([target,path,wave]);
 for(const pair of [[target,path],[path,wave]])if(!edgeKeys.has(pair.join('|'))){edgeKeys.add(pair.join('|'));edges.push(pair);}
}
const pathExplanations={
  "mito": "Mitochondria are structures inside cells that use fuel from food and oxygen to make adenosine triphosphate (ATP). ATP supplies energy for specific jobs, including muscle contraction, moving substances across cell membranes and building new proteins. Redox signaling involves chemical changes caused by the transfer of electrons. Reactive oxygen species (ROS), oxygen-containing molecules that react easily, can alter proteins and change their activity. In simple terms, this pathway connects the production of energy with changes in the proteins that control how a cell responds to workload or damage. The research examines both energy production and these chemical changes.",
  "no": "Nitric oxide (NO) is a small molecule that enters nearby cells. In blood-vessel walls, it starts reactions that relax the surrounding muscle, widening the vessel. Cytochrome-c oxidase (CCO) is a protein inside mitochondria, the structures that make usable cell energy. It helps complete a reaction involving oxygen during energy production, and nitric oxide interacts with it. In simple terms, this pathway links the amount of blood reaching tissue with the way cells use the oxygen that blood delivers.",
  "repair": "Reactive oxygen species (ROS) are oxygen-containing molecules that react with proteins. Those chemical changes alter protein activity; an excess also damages cell components. Nitric oxide (NO) helps relax blood-vessel walls. Calcium signaling means the amount of calcium inside a cell temporarily rises or falls. Calcium binds to proteins and changes their activity, controlling actions such as cell movement, release of substances and gene activity. Gene expression means using instructions in genes to make proteins. In simple terms, repair requires cells to receive information about damage, move to the right place and produce the materials needed to rebuild tissue.",
  "defense": "Nuclear factor kappa B (NF-κB) is a group of proteins that changes how often certain genes are read, including genes involved in inflammation. This changes the production of substances that attract and direct immune cells. Nuclear factor erythroid 2-related factor 2 (Nrf2) increases the production of proteins that help handle damaging chemical reactions. In simple terms, one part of this pathway organizes the response to injury or infection, while another helps protect cell components during that response. Researchers examine changes in these proteins and in the inflammatory and protective substances cells produce.",
  "quality": "Mitochondrial biogenesis means making new components of mitochondria, the structures that produce usable cell energy. Mitochondrial dynamics includes fusion, when mitochondria join and mix their contents, and fission, when they divide. Division helps separate damaged sections. Mitophagy is the process of breaking down and recycling damaged mitochondria. In simple terms, cells need to build energy-making structures, maintain them and remove parts that no longer work properly. These processes describe that maintenance, rather than simply the amount of energy available at one moment.",
  "porphyrin": "Porphyrins are light-absorbing molecules found in some bacteria. Photochemistry means that light energy starts chemical reactions. After absorbing blue light, porphyrins can help generate reactive oxygen species (ROS), oxygen-containing molecules that react with nearby material. These reactions damage bacterial proteins and membranes, the outer barriers that hold cells together. In simple terms, the light is absorbed by molecules inside susceptible bacteria, and the resulting chemistry damages those bacteria.",
  "opsin": "Opsins are light-sensitive proteins. Absorbing light changes their shape and starts a sequence of chemical reactions. Ion channels are proteins that form openings through the cell membrane, the thin barrier around a cell. They allow charged particles, including calcium, to move in or out. A change in calcium inside the cell changes the activity of proteins that control movement, release of substances or gene activity. In simple terms, the cell converts absorbed light into a change in its internal chemistry, and that change affects what the cell does.",
  "collagen": "Fibroblasts are cells that make the material surrounding and supporting skin cells. Collagen forms strong fibers that help skin resist stretching; elastic fibers help skin return toward its original shape after stretching. Fibroblast activation means an increase in the cells’ activity, and collagen synthesis means making new collagen protein. In simple terms, this pathway concerns the production of the material that gives skin its structure. The linked study examined skin samples and measured collagen, elastic fibers and fibroblast activity.",
  "thyroidsig": "Thyroxine (T4) and triiodothyronine (T3) are hormones released by the thyroid. They influence how cells use energy, including processes involved in heat production. Hashimoto’s disease involves an immune attack on the thyroid. Thyroid peroxidase antibodies are immune proteins directed against an enzyme the thyroid uses to make hormones. In simple terms, researchers measured whether participants needed a different amount of replacement hormone to maintain normal blood levels, and whether thyroid-directed immune proteins changed. These were measured outcomes in people with an underactive thyroid caused by Hashimoto’s disease.",
  "melatonin": "Melatonin is a hormone made mainly by the pineal gland, a small gland in the brain. It travels through the blood and binds to receptors, proteins that recognize it on receiving cells. This changes activity in systems that coordinate the body’s daily timing. In simple terms, melatonin helps communicate that it is nighttime, helping align sleep with the day–night cycle. The linked red-light study measured blood melatonin and participants’ own ratings of their sleep after 14 days.",
  "glucosepath": "Glucose is a sugar that cells take from the blood and use as fuel. Mitochondria help convert fuel into adenosine triphosphate (ATP), the molecule that supplies energy for cell work. Glucose utilization means taking up and using that sugar. In simple terms, if cells use more glucose, less of it remains in the blood. The study measured the blood-sugar response to a glucose drink after 670 nm light. Increased energy demand in mitochondria was the researchers’ proposed explanation for the smaller blood-sugar rise.",
  "wnt": "Wnt proteins bind to receptors, proteins on a cell that recognize them, and start reactions that affect β-catenin, pronounced beta-catenin. β-catenin helps change the reading of genes involved in growth. Hair follicles are structures in skin whose cells divide and produce the material forming a hair. In simple terms, this pathway changes instructions involved in keeping hair growing. In human follicles grown in a laboratory, 655 nm light increased pathway activity and hair-shaft length and reduced entry into the phase when growth slows and the follicle shrinks."
};
const waveExplanations={
  "blue": "Blue · 405–470 nm: This group connects to light-absorbing molecules in bacteria and light-sensitive proteins in skin. The 405–420 nm part is especially relevant to porphyrins, molecules in some bacteria that start damaging chemical reactions after absorbing light.",
  "green": "Green · 520–540 nm: This group connects to light-sensitive proteins and movement of calcium inside skin cells. Calcium changes the activity of proteins controlling tasks such as releasing substances or producing other proteins.",
  "red-low": "Red · 630–650 nm: This group brings together cell-energy and repair pathways with the skin study conducted at 633 nm. That study measured wrinkles, skin’s return to shape after stretching and collagen, the strong protein supporting skin.",
  "red-mid": "Red · 650–660 nm: This group contains the hair research at 655 nm and the sleep study at an average of 658 nm. It also includes 660 nm from the original cell-energy and repair schema. The hair study examined growth-related proteins and hair counts; the sleep study measured melatonin, a hormone that helps signal nighttime, and participants’ sleep ratings.",
  "red-high": "Red · 660–670 nm: This group contains 660 nm from the cell-energy and repair schema and the glucose study at 670 nm. The glucose study measured how high blood sugar rose and how long it stayed elevated after a glucose drink.",
  "nir": "NIR · 810–850 nm: Near-infrared (NIR) is invisible light beyond visible red and reaches relatively deeper tissue. This group combines the overlapping cell-energy and repair connections. The linked thyroid and skin studies used 830 nm: researchers measured replacement-hormone needs, wrinkles and collagen, the protein that supports skin."
};
const pathSummaries={
  "mito": "Mitochondrial respiration makes adenosine triphosphate (ATP), the molecule cells use to power work such as muscle contraction and tissue repair. Redox signaling changes the chemistry of proteins. In simple terms, those changes alter what the proteins do, helping the cell adjust energy production and its response to damage.",
  "no": "Nitric oxide (NO) tells muscle in blood-vessel walls to relax, making more room for blood to pass. Cytochrome-c oxidase (CCO) helps cells use oxygen to make energy. In simple terms, this pathway concerns both delivering oxygen to tissue and using that oxygen once it reaches cells.",
  "repair": "Reactive oxygen species (ROS) are oxygen-containing molecules that chemically alter proteins and change their activity. Nitric oxide (NO) helps blood vessels widen. A rise in calcium inside a cell activates proteins that control actions such as movement or release of substances. Gene expression makes proteins from genetic instructions. Together, these processes coordinate the work of repair.",
  "defense": "Nuclear factor kappa B (NF-κB) increases the reading of genes involved in inflammation. Nuclear factor erythroid 2-related factor 2 (Nrf2) increases the reading of genes involved in chemical protection. In simple terms, they change which proteins a cell makes: for example, proteins that call immune cells to an injury or proteins that help remove damaging molecules.",
  "quality": "Mitochondrial biogenesis builds components used to make cell energy. Dynamics means mitochondria join together or divide; joining allows contents to mix, while division helps separate damaged sections. Mitophagy breaks down damaged mitochondria. In simple terms, these are ways of building, maintaining and removing the structures that supply energy for cell work.",
  "porphyrin": "Porphyrins are molecules in some bacteria that absorb light. Photochemistry means the absorbed light supplies energy for a chemical reaction. In simple terms, this reaction produces substances that damage parts of susceptible bacteria, making it harder for those bacteria to survive.",
  "opsin": "Opsins are proteins that change shape when they absorb light. This starts a chain of chemical reactions. Ion channels are openings in the cell’s outer membrane that let charged particles enter or leave. In simple terms, light detection changes conditions inside a cell, affecting proteins that control actions such as releasing substances or changing gene activity.",
  "collagen": "Fibroblasts are cells that make collagen, a strong protein that supports skin. Activation means these cells increase their activity; synthesis means making new material. In simple terms, this pathway concerns producing and arranging the material that gives skin strength and structure.",
  "thyroidsig": "Thyroid hormones travel in blood and change how cells use energy, affecting processes such as heat production. In Hashimoto’s disease, the immune system attacks the thyroid. In simple terms, the study examined how much replacement hormone people needed and measured immune proteins directed against the gland.",
  "melatonin": "Melatonin is a hormone that binds to receiving proteins on cells involved in the body’s daily timing. In simple terms, it helps tell the body that it is nighttime. The study measured melatonin in blood and asked participants about their sleep.",
  "glucosepath": "Glucose utilization means taking sugar from the blood into cells and using it as fuel. Mitochondrial metabolism is part of the process that turns fuel into usable energy. In simple terms, the researchers tested whether light exposure changed how much sugar remained in the blood after a glucose drink.",
  "wnt": "Wnt is a family of proteins that bind to receiving proteins on cells. β-catenin, pronounced beta-catenin, then helps change which genes are read. In simple terms, this pathway controls instructions involved in growing hair. The laboratory study measured these proteins and growth in human hair follicles, the structures in skin that produce hair."
};
const studyEvidence={
  "aging": [
    [
      "Human study · 76 participants",
      "633 / 830 nm: Participants were randomly assigned to treatment groups. Researchers found fewer wrinkles, better return of skin to its shape after stretching, and more collagen, the protein that supports skin.",
      "https://pubmed.ncbi.nlm.nih.gov/17566756/"
    ]
  ],
  "thyroid": [
    [
      "Human study · 43 people with an underactive thyroid caused by immune attack",
      "830 nm: Compared with the group given an inactive treatment, the light-treated group needed less replacement thyroid hormone to maintain normal blood hormone levels at nine months. Blood tests also showed lower levels of immune proteins directed against a thyroid enzyme.",
      "https://pubmed.ncbi.nlm.nih.gov/22718472/"
    ]
  ],
  "sleep": [
    [
      "Human study · 20 female basketball players",
      "658 nm: After 14 days, athletes in the light group reported better sleep and had higher blood levels of melatonin, the hormone that helps signal nighttime, compared with the no-light group.",
      "https://pmc.ncbi.nlm.nih.gov/articles/PMC3499892/"
    ]
  ],
  "glucose": [
    [
      "Human study · healthy adults",
      "670 nm: The researchers combined the height and duration of the blood-sugar rise into one measurement across two hours. That measurement was 27.7% lower after a 15-minute light exposure before the glucose drink.",
      "https://pubmed.ncbi.nlm.nih.gov/38378043/"
    ]
  ],
  "hair": [
    [
      "Human study · women with pattern hair loss",
      "655 nm: Women were randomly assigned to an active or inactive light device. Hair counts increased more in the active-device group.",
      "https://pubmed.ncbi.nlm.nih.gov/25124964/"
    ],
    [
      "Laboratory study · human hair follicles grown outside the body",
      "655 nm: Researchers measured changes in Wnt / β-catenin, proteins involved in reading growth-related genes, and found increased activity together with longer hairs produced by the follicles.",
      "https://pubmed.ncbi.nlm.nih.gov/29468283/"
    ]
  ]
};
const el=new Map();let selected=null,active=new Set(),activeEdges=new Set();
const getNode=id=>nodes.find(n=>n[0]===id);
const wavelengthColors={blue:'#529dff',green:'#63d68b','red-low':'#ff7878','red-mid':'#ff7878','red-high':'#ff7878',nir:'#c394ff'};
function routeColors(matchingRoutes){return [...new Set(matchingRoutes.map(r=>wavelengthColors[r[2]]).filter(Boolean))];}
function tint(element,colors){
 if(!colors.length){element.style.removeProperty('--wave-fill');element.style.removeProperty('--wave-border');return;}
 const stops=colors.length===1?[colors[0],colors[0]]:colors;
 element.style.setProperty('--wave-fill','linear-gradient(110deg,'+stops.map(c=>c+'38').join(',')+')');
 element.style.setProperty('--wave-border',colors[0]);
}

const mobileView=document.createElement('div');mobileView.className='matrix-mobile';
const targetLabel=document.createElement('label');targetLabel.htmlFor='matrix-health-target';targetLabel.textContent='Health target';
const targetSelect=document.createElement('select');targetSelect.id='matrix-health-target';
const placeholder=document.createElement('option');placeholder.value='';placeholder.textContent='Select a health target';targetSelect.append(placeholder);
nodes.filter(n=>n[1]===0).forEach(([id,,label])=>{const option=document.createElement('option');option.value=id;option.textContent=label;targetSelect.append(option);});
const mobileResults=document.createElement('div');mobileResults.className='matrix-mobile-results';mobileResults.hidden=true;mobileResults.setAttribute('aria-live','polite');
mobileView.append(targetLabel,targetSelect,mobileResults);root.prepend(mobileView);
targetSelect.addEventListener('change',()=>{selected=null;selectNode(targetSelect.value||null);});
function updateMobile(selectedRoutes){
 const target=selected&&getNode(selected)[1]===0?selected:selectedRoutes[0]?.[0];
 targetSelect.value=target||'';mobileResults.replaceChildren();mobileResults.hidden=!target;
 if(!target)return;
 const targetRoutes=routes.filter(r=>r[0]===target);
 for(const [index,title] of [[1,'Cellular pathway'],[2,'Light wavelength']]){
  const group=document.createElement('section'),heading=document.createElement('h3'),list=document.createElement('ul');heading.textContent=title;
  [...new Set(targetRoutes.map(r=>r[index]))].forEach(id=>{const item=document.createElement('li');item.textContent=getNode(id)[2];tint(item,routeColors(targetRoutes.filter(r=>r[index]===id)));list.append(item);});
  group.append(heading,list);mobileResults.append(group);
 }
}

function selectNode(id){
if(id&&!selected&&getNode(id)[1]!==0)return;
selected=selected===id?null:id;
const selectedRoutes=selected?routes.filter(r=>r.includes(selected)):[];
updateMobile(selectedRoutes);
active=new Set(selectedRoutes.flat());activeEdges=new Set();
selectedRoutes.forEach(([a,b,c])=>{activeEdges.add(a+'|'+b);activeEdges.add(b+'|'+c);});
root.querySelector('.prompt').hidden=!!selected;
root.querySelector('.explanation').hidden=!selected;
if(selected){
 const lane=getNode(selected)[1];
 const targets=[...new Set(selectedRoutes.map(r=>r[0]))],paths=[...new Set(selectedRoutes.map(r=>r[1]))],waves=[...new Set(selectedRoutes.map(r=>r[2]))];
 root.querySelector('.route-label').textContent=getNode(selected)[2];
 root.querySelector('.context-text').textContent=lane===0?getNode(selected)[3]:'Health targets: '+targets.map(t=>getNode(t)[2]).join('; ')+'.';
 const pathBox=root.querySelector('.path-text');pathBox.replaceChildren();
 if(lane===1){const p=document.createElement('p');p.textContent=pathExplanations[selected];pathBox.append(p);}
 else paths.forEach(id=>{const p=document.createElement('p');p.textContent=getNode(id)[2]+': '+pathSummaries[id];pathBox.append(p);});
 const studyBox=root.querySelector('.study-text');studyBox.replaceChildren();
 targets.filter(t=>getNode(selected)[1]!==1||['collagen','thyroidsig','melatonin','glucosepath','wnt'].includes(selected)).forEach(t=>(studyEvidence[t]||[]).forEach(([label,result,url])=>{
  const p=document.createElement('p');p.textContent=label+': '+result+' ';
  const link=document.createElement('a');link.href=url;link.textContent='Read study';link.target='_blank';link.rel='noopener noreferrer';p.append(link);studyBox.append(p);
 }));
 const waveBox=root.querySelector('.wave-text');waveBox.replaceChildren();
 if(lane===2){const p=document.createElement('p');p.textContent=waveExplanations[selected];waveBox.append(p);}
 else {const p=document.createElement('p');p.textContent='Light wavelengths: '+waves.map(w=>getNode(w)[2]).join('; ')+'.';waveBox.append(p);}
}
draw();
if(selected){
 requestAnimationFrame(()=>{
  const detail=root.querySelector('.detail');
  const header=document.querySelector('header-component');
  const top=(header?header.getBoundingClientRect().height:80)+16;
  const box=detail.getBoundingClientRect();
  if(box.top<top||box.top+Math.min(box.height,280)>window.innerHeight){
   window.scrollTo({top:window.scrollY+box.top-top,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
 });
}
}
nodes.forEach(([id,lane,label,detail])=>{
const wrap=document.createElement('div');wrap.className='node';
const b=document.createElement('button');b.type='button';b.className='btn btn-block';const labelSpan=document.createElement('span');labelSpan.className='node-label';labelSpan.textContent=label;b.append(labelSpan);b.setAttribute('aria-pressed','false');b.setAttribute('aria-label',label+'. '+detail);b.addEventListener('click',()=>selectNode(id));wrap.append(b);root.querySelector('[data-lane="'+lane+'"]').append(wrap);el.set(id,b);
});
const svg=root.querySelector('.edges'), network=root.querySelector('.network');
function draw(){
const box=network.getBoundingClientRect(), mobile=getComputedStyle(network).gridTemplateColumns.split(' ').length===1;
svg.setAttribute('viewBox','0 0 '+box.width+' '+box.height);svg.replaceChildren();

if(!window.matchMedia('(max-width:820px)').matches) edges.forEach(([a,b])=>{
const ra=el.get(a).getBoundingClientRect(),rb=el.get(b).getBoundingClientRect();
const on=!!selected&&activeEdges.has(a+'|'+b);
const path=document.createElementNS('http://www.w3.org/2000/svg','path');
const y1=ra.top-box.top+ra.height/2,y2=rb.top-box.top+rb.height/2;
let d;
if(mobile){const left=nodes.find(n=>n[0]===a)[1]===0;const x=left?ra.left-box.left:ra.right-box.left;const x2=left?rb.left-box.left:rb.right-box.left;const gutter=left?4:box.width-4;d=`M ${x} ${y1} C ${gutter} ${y1}, ${gutter} ${y2}, ${x2} ${y2}`;}
else{const x1=ra.right-box.left,x2=rb.left-box.left,mid=(x1+x2)/2;d=`M ${x1} ${y1} C ${mid} ${y1}, ${mid} ${y2}, ${x2} ${y2}`;}
const colors=routeColors(routes.filter(r=>(r[0]===a&&r[1]===b||r[1]===a&&r[2]===b)&&(!selected||r.includes(selected))));
let stroke=colors[0]||'var(--border)';
if(on&&colors.length>1){
 const gradient=document.createElementNS('http://www.w3.org/2000/svg','linearGradient');gradient.id='wave-edge-'+a+'-'+b;
 colors.forEach((color,index)=>{const stop=document.createElementNS('http://www.w3.org/2000/svg','stop');stop.setAttribute('offset',String(index/(colors.length-1)));stop.setAttribute('stop-color',color);gradient.append(stop);});
 svg.append(gradient);stroke='url(#'+gradient.id+')';
}
path.setAttribute('d',d);path.setAttribute('fill','none');path.setAttribute('stroke',on?stroke:'var(--border)');path.setAttribute('stroke-width',on&&selected?'2':'1');path.setAttribute('opacity',on?(selected?'0.85':'0.35'):'0.3');svg.append(path);
});
for(const [id,b]of el){tint(b,active.has(id)?routeColors(routes.filter(r=>r.includes(id)&&r.includes(selected))):[]);b.setAttribute('aria-pressed',String(active.has(id)));b.parentElement.style.opacity=active.has(id)?'1':'0.55';b.disabled=!selected&&getNode(id)[1]!==0;}
}
new ResizeObserver(draw).observe(network);draw();
})();
